import React, { useEffect, useState } from 'react';

// A simple global event emitter for toasts
type ToastEvent = {
  message: string;
  duration?: number;
};

type ToastListener = (event: ToastEvent) => void;

class ToastManager {
  private listeners: ToastListener[] = [];

  subscribe(listener: ToastListener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  show(message: string, duration = 1900) {
    this.listeners.forEach(listener => listener({ message, duration }));
  }
}

export const toastManager = new ToastManager();

export const toast = (message: string, duration?: number) => {
  toastManager.show(message, duration);
};

export const ToastContainer: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const handleToast = (event: ToastEvent) => {
      setMessage(event.message);
      setIsVisible(true);

      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsVisible(false);
      }, event.duration);
    };

    const unsubscribe = toastManager.subscribe(handleToast);

    return () => {
      unsubscribe();
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      <div className={`cab-toast ${isVisible ? 'show' : ''}`}>
        {message}
      </div>
      <style>{`
        .cab-toast {
          position: fixed;
          bottom: 90px;
          left: 50%;
          transform: translateX(-50%);
          background: var(--cab-violet);
          color: #fff;
          padding: 11px 20px;
          border-radius: 100px;
          font-size: 13px;
          font-weight: 500;
          z-index: 70;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.25s ease, transform 0.25s ease;
          white-space: nowrap;
          box-shadow: 0 4px 12px rgba(54, 23, 119, 0.2);
        }
        .cab-toast.show {
          opacity: 1;
        }
      `}</style>
    </>
  );
};
